import { getAPI, type FetchResponse, type UserAPI } from '@sydle/ui-api';
import { blogCustomAPI } from './index';
import { getApp } from '@sydle/ui-utils';

export interface registerUserConsentsInput {
  appIdentifier?: string;
  consents: string[];
  lang?: string;
  hash?: string;
}

export type registerUserConsentsOutput = { newSubscriptions: any };

export async function registerUserConsents(
  input: registerUserConsentsInput,
): Promise<FetchResponse<registerUserConsentsOutput>> {
  const response = await blogCustomAPI.fetch<registerUserConsentsInput, registerUserConsentsOutput>(
    'registerUserConsents',
    {
      ...input,
      lang: getAPI<UserAPI>('userAPI')?.getCurrentLanguage() || 'en',
      hash: getApp()?.hash,
      appIdentifier: getApp()?.identifier,
    },
  );

  return response;
}
